interface SpinnerProps {
  className?: string;
  strokeWidth?: number;
}

export default function Spinner({
  className = 'w-6 h-6',
  strokeWidth = 8,
}: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={`animate-spin ${className}`}
      style={{ animationDuration: '1.4s' }}
      aria-hidden
    >
      {/* Track — faint full ring behind */}
      <circle
        cx="50"
        cy="50"
        r="42"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        opacity={0.2}
      />
      {/* Animated arc — shrinks and grows on top */}
      <circle
        cx="50"
        cy="50"
        r="42"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        style={{
          animation: 'spinner-dash 1.4s ease-in-out infinite',
        }}
      />
    </svg>
  );
}
